export default __webpack_public_path__ + "static/media/hmd_background_s1.82c3bb69.jpg";